import mapPresenceChange, { RawPresenceChange } from './mapPresenceChange';
import mapProductHistoryCompanyChange, { RawProductHistoryCompanyChange } from './mapProductHistoryCompanyChange';
import mapProductHistoryPriceChange, { RawProductHistoryPriceChange } from './mapProductHistoryPriceChange';
import { mapProductHistoryProduct, RawProductHistoryProduct } from './mapProductHistoryProduct';
import ProductHistoryEvent, { Type } from './ProductHistoryEvent';

export interface RawProductHistoryEvent {
	eventType: string;
	product: RawProductHistoryProduct;
	companyChange: RawProductHistoryCompanyChange | null;
	priceChange: RawProductHistoryPriceChange | null;
	presenceChange: RawPresenceChange | null;
	effectiveSince: string;
}

export default function mapProductHistoryEvent(event: RawProductHistoryEvent): ProductHistoryEvent {
	return new ProductHistoryEvent(
		event.eventType as Type,
		mapProductHistoryProduct(event.product),
		event.companyChange !== null ? mapProductHistoryCompanyChange(event.companyChange) : null,
		event.priceChange !== null ? mapProductHistoryPriceChange(event.priceChange) : null,
		event.presenceChange !== null ? mapPresenceChange(event.presenceChange) : null,
		new Date(event.effectiveSince)
	);
}
